import { css } from "@emotion/react";

import { useFormattedNumber } from "shared/hooks/useFormattedNumber";

import Cards from "./Cards";
import CheckboxOption from "./CheckboxOption";
import CountText from "./CountText";
import { CompatibilityContentProps } from "./types";
import WarningMessage from "./WarningMessage";

const CompatibilityContent = ({
    data,
    activeSource,
    secondSelectName,
    differentData,
    isCancelTasksChecked,
    schedule,
    hasCreateForIncompatible,
    isLoading,
    handleCreateForIncompatible
}: CompatibilityContentProps) => {
    const { renderFormattedNumber } = useFormattedNumber();

    const {
        compatible_device_platforms,
        compatible_model_device_count,
        device_count,
        task_type
    } = data;

    const compatibleCount = renderFormattedNumber(
        compatible_model_device_count
    );

    const totalCount = renderFormattedNumber(device_count);

    const areAllCompatible = compatible_model_device_count === device_count;

    return (
        <div
            css={css({
                margin: "4px 0"
            })}
        >
            {!areAllCompatible && <WarningMessage />}

            <Cards
                compatiblePlatforms={compatible_device_platforms}
                compatibleCount={compatibleCount}
                totalCount={totalCount}
                taskType={task_type}
                activeSource={activeSource}
                secondSelectName={secondSelectName}
                differentData={differentData}
                isCancelTasksChecked={isCancelTasksChecked}
                schedule={schedule}
            />

            {!areAllCompatible && (
                <CountText
                    compatibleCount={compatibleCount}
                    totalCount={totalCount}
                    hasCreateForIncompatible={hasCreateForIncompatible}
                />
            )}

            {!areAllCompatible && (
                <CheckboxOption
                    value={hasCreateForIncompatible}
                    isLoading={isLoading}
                    onChange={handleCreateForIncompatible}
                />
            )}
        </div>
    );
};

export default CompatibilityContent;
